import { useQuery } from 'react-query';
import { api } from 'api/api';

export const useGetUpcomingGames = (leagueId) =>
  useQuery({
    queryKey: ['getUpcomingGames', leagueId],
    queryFn: () => api.games.getUpcomingGames({ leagueId }),
    enabled: !!leagueId,
  });
